module.exports = __webpack_public_path__ + "img/add-folder-icon.cf801ba4.svg";